(() => {
  const rootSelector = '[data-mr-palworld-singles]';

  const initialiseDialog = (root) => {
    if (root.dataset.mrDialogReady === 'true') return;

    const trigger = root.querySelector('[data-mr-palworld-filter-open]');
    const dialog = root.querySelector('[data-mr-palworld-filter-dialog]');
    const closeButton = root.querySelector('[data-mr-palworld-filter-close]');
    if (!trigger || !dialog || !closeButton) return;

    root.dataset.mrDialogReady = 'true';
    let returnFocus = trigger;

    if (dialog.open) dialog.removeAttribute('open');
    dialog.setAttribute('aria-modal', 'false');

    const openDialog = () => {
      returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : trigger;
      dialog.classList.add('is-open');
      dialog.setAttribute('aria-modal', 'true');
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mr-palworld-filter-open');
      window.requestAnimationFrame(() => closeButton.focus());
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    trigger.addEventListener('click', openDialog);
    closeButton.addEventListener('click', closeDialog);

    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeDialog();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', () => {
      dialog.classList.remove('is-open');
      dialog.setAttribute('aria-modal', 'false');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mr-palworld-filter-open');
      if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    });
  };

  const initialiseRoot = (root) => {
    initialiseDialog(root);
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach(initialiseRoot);
  };

  document.addEventListener('DOMContentLoaded', () => initialiseAll());
  window.addEventListener('load', () => {
    initialiseAll();
  });
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
